module.exports = __webpack_public_path__ + "static/media/botanicalBedroom.6ba0fac6.jpg";